import { createContext, useContext } from 'react';

// Where ticket actions go: the owner's API by default, or a guest's own tracker on the Nick's Picks link.
const OWNER = { base: `${process.env.REACT_APP_BACKEND_URL}/api/sports-betting`, headers: {} };
export const TicketApi = createContext(OWNER);
export const useTicketApi = () => useContext(TicketApi);
